import script from "./BloodTest.vue?vue&type=script&setup=true&lang=js"
export * from "./BloodTest.vue?vue&type=script&setup=true&lang=js"

import "./BloodTest.vue?vue&type=style&index=0&id=597016e8&lang=css"

const __exports__ = script;

export default __exports__